<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="country && country.id">{{ 'COUNTRIES.COUNTRIES_FORM.EDIT_COUNTRY' | translate }}</span>
    <span *ngIf="!country || !country.id">{{ 'COUNTRIES.COUNTRIES_FORM.ADD_COUNTRY' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="countries-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="form-group">
      <label>{{ 'COUNTRIES.COUNTRIES_FORM.NAME' | translate }}</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>

    <div class="form-group">
      <label>{{ 'COUNTRIES.COUNTRIES_FORM.CODE' | translate }}</label>
      <input type="text" class="form-control" formControlName="code" />
    </div>

    <div class="form-group">
      <label>{{ 'COUNTRIES.COUNTRIES_FORM.PHONE_CODE' | translate }}</label>
      <input type="number" class="form-control" formControlName="phone_code" />
    </div>

    <app-timezone-select [parentFormGroup]="form"></app-timezone-select>

    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" formControlName="active" />
      <label class="form-check-label">{{ 'COUNTRIES.COUNTRIES_FORM.ACTIVE' | translate }}</label>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="countries-form" [disabled]="form.invalid">
    {{ 'COUNTRIES.COUNTRIES_FORM.SAVE' | translate }}
  </button>
</div>
